<div
  class="card"
  *appIsGranted="['TOOLS_TRANSLATE', 'TOOLS_TRANSLATE', 'READ']"
>
  <div class="card-body">
    <!-- Nav tabs -->
    <ul
      ngbNav
      #customNav="ngbNav"
      [activeId]="1"
      class="nav nav-tabs nav-tabs-custom"
    >
      <li [ngbNavItem]="1">
        <a ngbNavLink>
          <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
          <span class="d-none d-sm-block">Tradutor pacotes da Maxtrack</span>
        </a>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="TabTranslate"></ng-template>
        </ng-template>
      </li>
      <li [ngbNavItem]="2" (click)="requestProfileList()">
        <a ngbNavLink>
          <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
          <span class="d-none d-sm-block">Tradutor com diff Profile</span>
        </a>
        <ng-template ngbNavContent>
          <ng-template
            [ngTemplateOutlet]="TabTranslateDiffProfile"
          ></ng-template>
        </ng-template>
      </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content p-3 text-muted">
      <div [ngbNavOutlet]="customNav"></div>
    </div>
  </div>
</div>

<!-- Tab Translate-->
<ng-template #TabTranslate>
  <div class="card m-3">
    <div class="card">
      <div class="card-body column">
        <div class="row">
          <h6 class="card">Traduzir pacotes da maxtrack</h6>
          <div class="col-md-7">
            <label for="serial" class="col-md-2 col-form-label">Pacote</label>
            <input
              class="w-75"
              placeholder="Inserir o pacote bruto em hexa"
              [(ngModel)]="packet"
            />
          </div>
          <div class="col-md-3">
            <div class="column">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style="margin-right: 5px"
                (click)="translate(packet)"
              >
                Traduzir
              </button>
            </div>
          </div>
          <div class="col-md-2 d-inline">
            <input
              class="form-check-input ms-2"
              type="radio"
              name="formRadios"
              id="formRadios1"
              value="0"
              [(ngModel)]="prettyEvent"
              checked
            />
            <label class="form-check-label" for="formRadios1"> 0 </label>
            <input
              class="form-check-input ms-2"
              type="radio"
              name="formRadios"
              id="formRadios2"
              value="1"
              [(ngModel)]="prettyEvent"
            />
            <label class="form-check-label" for="formRadios2"> 1 </label>
            <input
              class="form-check-input ms-2"
              type="radio"
              name="formRadios"
              id="formRadios3"
              value="2"
              [(ngModel)]="prettyEvent"
            />
            <label class="form-check-label" for="formRadios2"> 2 </label>
          </div>
        </div>
      </div>
    </div>
    <div class="card align-items-center" *ngIf="circularProgressiveWait">
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="card-header">
      {{ packetHeader }}
    </div>
    <div class="card p-3">
      <div>
        <div *ngIf="prettyEvent == '0'">
          <ngx-json-viewer
            [json]="packetTranslated"
            [depth]="8"
            [expanded]="true"
          ></ngx-json-viewer>
        </div>

        <div *ngIf="prettyEvent == '1'">
          <ngx-json-viewer
            [json]="packetTranslated"
            [expanded]="false"
          ></ngx-json-viewer>
        </div>
        <div *ngIf="prettyEvent == '2'">
          <p [innerHTML]="packetTranslated | json"></p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Tab Translate-->
<ng-template #TabTranslateDiffProfile>
  <div class="card m-3">
    <div class="card">
      <div class="card-body column">
        <div class="row">
          <h6 class="card">Traduzir com Diff Profile</h6>
          <div class="col-md-7">
            <label for="serial" class="col-md-2 col-form-label"
              >Pacote de Configuração</label
            >
            <input
              class="w-100"
              placeholder="Inserir aqui o pacote de configuração (hexa)"
              [(ngModel)]="packetProfileDiff"
            />
            <div class="col-md-2 d-inline">
              <input
                class="form-check-input ms-2"
                type="radio"
                name="formRadiosPacket1"
                id="formRadiosPacket1"
                value="0"
                [(ngModel)]="prettyEventDiffPacket"
                checked
              />
              <label class="form-check-label" for="formRadiosPacket1">
                0
              </label>
              <input
                class="form-check-input ms-2"
                type="radio"
                name="formRadiosPacket2"
                id="formRadiosPacket2"
                value="1"
                [(ngModel)]="prettyEventDiffPacket"
              />
              <label class="form-check-label" for="formRadiosPacket2">
                1
              </label>
              <input
                class="form-check-input ms-2"
                type="radio"
                name="formRadiosPacket3"
                id="formRadiosPacket3"
                value="2"
                [(ngModel)]="prettyEventDiffPacket"
              />
              <label class="form-check-label" for="formRadiosPacket3">
                2
              </label>
            </div>
          </div>
          <div class="col">
            <div class="column">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style="margin-right: 5px"
                (click)="translateAndRequestProfile()"
              >
                Comparar
              </button>
            </div>
          </div>
          <div class="col">
            <ng-select
              class="custom"
              id="profileSelect"
              placeholder="Selecione um profile"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="profileSelect"
              [searchable]="true"
              [markFirst]="true"
            >
              <ng-option
                *ngFor="let profile of profileFilesName"
                [value]="profile.fileId"
              >
                {{ profile.name }}
              </ng-option>
            </ng-select>
            <div class="col-md-2 d-inline">
              <input
                class="form-check-input ms-2"
                type="radio"
                name="formRadiosFile1"
                id="formRadiosFile1"
                value="0"
                [(ngModel)]="prettyEventDiffFile"
                checked
              />
              <label class="form-check-label" for="formRadiosFile1"> 0 </label>
              <input
                class="form-check-input ms-2"
                type="radio"
                name="formRadiosFile2"
                id="formRadiosFile2"
                value="1"
                [(ngModel)]="prettyEventDiffFile"
              />
              <label class="form-check-label" for="formRadiosFile2"> 1 </label>
              <input
                class="form-check-input ms-2"
                type="radio"
                name="formRadiosFile3"
                id="formRadiosFile3"
                value="2"
                [(ngModel)]="prettyEventDiffFile"
              />
              <label class="form-check-label" for="formRadiosFile3"> 2 </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card align-items-center"
      *ngIf="circularProgressiveDiffConfigWait"
    >
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col card m-2">
        <h4>Pacote Traduzido</h4>
        <div>
          <div *ngIf="prettyEventDiffPacket == '0'">
            <ngx-json-viewer
              [json]="packetDocumentContents"
              [depth]="4"
            ></ngx-json-viewer>
          </div>

          <div *ngIf="prettyEventDiffPacket == '1'">
            <ngx-json-viewer
              [json]="packetDocumentContents"
              [expanded]="false"
            ></ngx-json-viewer>
          </div>
          <div *ngIf="prettyEventDiffPacket == '2'">
            <p [innerHTML]="packetDocumentContents | json"></p>
          </div>
        </div>
      </div>
      <div class="col card m-2">
        <h4>Arquivo Traduzido</h4>
        <div>
          <div *ngIf="prettyEventDiffFile == '0'">
            <ngx-json-viewer
              [json]="fileDocumentContents"
              [depth]="4"
            ></ngx-json-viewer>
          </div>

          <div *ngIf="prettyEventDiffFile == '1'">
            <ngx-json-viewer
              [json]="fileDocumentContents"
              [expanded]="false"
            ></ngx-json-viewer>
          </div>
          <div *ngIf="prettyEventDiffFile == '2'">
            <p [innerHTML]="fileDocumentContents | json"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
